import React, { useState, useEffect } from "react";
import { Checkbox } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";

const LoadTypeCheckbox = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const loadTypes = [
        {
            loadTypeId : 1,
            loadTypeName : "Frozen"
        },
        {
            loadTypeId : 2,
            loadTypeName : "Chilled"
        },
        {
            loadTypeId : 3,
            loadTypeName : "Ambient"
        },
        {
            loadTypeId : 4,
            loadTypeName : "Dry"
        }
    ]
    const [loadTypeSelected, setLoadTypeSelected] = useState([])

    useEffect(()=>{
        if(props?.loadTypeIds?.length){
            setLoadTypeSelected(props.loadTypeIds)
        }
    },[props?.loadTypeIds])

    let handleChange = (e,data) => {
        let load_type_selected = loadTypeSelected
        if(data.name == "all_items"){
            if(data.checked){
                load_type_selected = [1,2,3,4]
            }else{
                load_type_selected = []
            }
        }else{
            if(data.checked){
                load_type_selected.push(data.id)
            }else{
                load_type_selected = load_type_selected.filter((id)=> id !== data.id)
            }
        }
        setLoadTypeSelected(load_type_selected)
        setFieldValue(name, load_type_selected)
    };
    let isChecked = (id) => {
        let load_type_selected = loadTypeSelected
        return load_type_selected.includes(id)
    }
    return (
        <div className="row ml-4">
            {loadTypes.map((obj) => {
                return (
                    <Checkbox
                        onChange={handleChange}
                        id={obj.loadTypeId}
                        name={obj.loadTypeName}
                        type="checkbox"
                        className="form-check-input large mr-5"
                        label={obj.loadTypeName}
                        checked={isChecked(obj.loadTypeId)}
                    />

                )
            })
            }

            <Checkbox
                onChange={handleChange}
                name={"all_items"}
                type="checkbox"
                className="form-check-input large ml-1 mr-5"
                label={"Select All"}
            />

        </div>
    );
};

export default LoadTypeCheckbox;
